var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleAfter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12.407,
    viewBox: "0 0 14 12.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "keyboard_double_arrow_right_FILL0_wght300_GRAD0_opsz40",
    d: "M240.467-690.281l-4.965-4.979a.712.712,0,0,1-.216-.5.658.658,0,0,1,.216-.509.7.7,0,0,1,.508-.219.7.7,0,0,1,.508.219l5.358,5.358a.881.881,0,0,1,.2.294.9.9,0,0,1,.06.336.909.909,0,0,1-.06.332.871.871,0,0,1-.2.3l-5.358,5.358a.7.7,0,0,1-.5.212.685.685,0,0,1-.513-.212.7.7,0,0,1-.219-.508.7.7,0,0,1,.219-.508Zm7.144,0-4.965-4.979a.686.686,0,0,1-.22-.5.67.67,0,0,1,.22-.509.673.673,0,0,1,.5-.219.7.7,0,0,1,.508.219l5.365,5.358a.881.881,0,0,1,.2.294.9.9,0,0,1,.06.336.909.909,0,0,1-.06.332.871.871,0,0,1-.2.3l-5.365,5.358a.7.7,0,0,1-.5.212.68.68,0,0,1-.509-.212.7.7,0,0,1-.219-.508.7.7,0,0,1,.219-.508Z",
    transform: "translate(-235.283 696.487)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleAfter);
export default __webpack_public_path__ + "static/media/double-after.dc05db53c68a9ebe290ebcca9c8e7651.svg";
export { ForwardRef as ReactComponent };